import { BuilderConfig } from '../../../types/Builder';
import { COLORS } from '../../business-button/business-button.constants';

import B2BCarouselLifecycle, { B2BCarouselLifecycleProps } from './b2b-carousel-lifecycle';

export const B2BCarouselLifecycleBuilderConfig = {
    name: 'B2B Carousel Lifecycle',
    inputs: [
        {
            name: 'title',
            type: 'html',
        },
        {
            name: 'subTitle',
            type: 'string',
        },
        {
            name: 'autoplay',
            type: 'boolean',
        },
        {
            name: 'optionButton',
            type: 'object',
            subFields: [
                {
                    name: 'buttonText',
                    type: 'string',
                },
                {
                    name: 'buttonLink',
                    type: 'string',
                },

                {
                    name: 'buttonColor',
                    type: 'string',
                    enum: Object.values(COLORS),
                    defaultValue: COLORS.MINT,
                },
            ],
        },
        {
            name: 'backgroundColor',
            type: 'color',
        },
        {
            name: 'colorText',
            type: 'color',
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                },

                {
                    name: 'title',
                    type: 'html',
                },

                {
                    name: 'description',
                    type: 'html',
                },
                {
                    name: 'backgroundContent',
                    type: 'color',
                },
                {
                    name: 'buttonText',
                    type: 'string',
                },
                {
                    name: 'buttonLink',
                    type: 'string',
                },
                {
                    name: 'tileClickable',
                    type: 'boolean',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BCarouselLifecycleProps> = {
    component: B2BCarouselLifecycle,
    config: B2BCarouselLifecycleBuilderConfig,
};

export default builderConfig;
